import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { FormFields } from '@epi-forms/helpers';
import { ON_HOLD, Schedule } from '@epi-constants/benefitTypes';
import { topupSliceActions } from '@epi-store/topup/topup.slice';

export const useTopupFormContext = () => {
  const dispatch = useDispatch();

  const form = useForm({
    mode: 'onChange',
    defaultValues: {
      [FormFields.MoneyAmount]: '',
      [FormFields.Benefit]: '',
      [FormFields.Page]: 1,
      [FormFields.CheckableEmployees]: [],
      [FormFields.ScheduleType]: Schedule.Direct,
      [FormFields.ScheduleDate]: ''
    }
  });

  const { watch } = form;
  const checkableEmployees = watch(FormFields.CheckableEmployees) as any[];

  useEffect(() => {
    const isOnHoldEmployee = !!checkableEmployees.find(
      employee => employee.employmentType === ON_HOLD
    );

    if (isOnHoldEmployee) {
      dispatch(topupSliceActions.toggleShowTable(true));
    }
  }, [checkableEmployees]);

  useEffect(() => {
    return () => {
      dispatch(topupSliceActions.toggleShowTable(false));
    };
  }, []);

  return { form };
};
